import React, { ReactNode } from 'react';

interface SectionProps {
    id?: string;
    title?: string;
    children: ReactNode;
    className?: string;
    isHidden?: boolean;
}
const Section: React.FC<SectionProps> = ({
    id,
    title,
    children,
    className = '',
    isHidden = false,
}) => {
    if (isHidden) return null;
    return (
        <section
            id={id}
            className={`max-lg:my-5 relative flex flex-col items-start justify-start w-full ${className}`}
        >
            {title && (
                <h2 className='mb-4 mt-2 flex w-full justify-start text-gray-900 dark:text-white font-bold text-sm lg:text-base'>
                    {title}
                </h2>
            )}
            {children}
        </section>
    );
};

export default Section;
